import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AppGlobals } from '@app/app.global';
import { AuthService, EntityService, PageMetaService, SharedService, User } from '@app/core';
import { HomeLayoutComponent } from '@app/layout';
import { ReportService } from '@app/modules/report/services';
import { VoucherService } from '@modules/voucher/services';
import { PmdSidebar } from '@shared/propeller';
import { Observable, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SideBarSection } from './sidebar.section';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  animations: [
    trigger('collapseExpand', [
      state('void', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
      state('*', style({ height: '*', opacity: 1, overflow: 'hidden' })),
      transition('void <=> *', animate('300ms ease-in-out')),
    ])]
})
export class SidebarComponent implements OnInit {
  @ViewChild(PmdSidebar) leftSidebar: { toggleSideBar: () => void; };
  @Input() isOpen: boolean;
  isWithTags: any = false;
  url$: Observable<string> = new Observable<string>();
  currentURL: string;
  loggedinUser: User;
  showPushToPetpooja: boolean = false;
  showPushToRetailPos: boolean = false;
  showPushToTally: boolean = false;
  productTagsSubscription: Subscription;
  companyDetailsSubscription: Subscription;
  canShowBeneficiary = false;
  isLeadAdminModuleAccess: boolean = false;
  token: string;
  canShowMobileSubmenu = false;
  @ViewChild(HomeLayoutComponent) homeLayoutComponent!: HomeLayoutComponent;
  loggedInUserThumbnail: string;

  topSections: any[] = [];
  bottomSections: any[] = [];
  activeMenu: any;
  isSettingsSidebar = false;
  sideBarSection: SideBarSection;
  canAdminViewReport = false;
  canAdminUpload = false;

  constructor(private sharedService: SharedService,
    public appGlobals: AppGlobals,
    public authService: AuthService,
    private entityService: EntityService,
    private voucherService: VoucherService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private readonly pageMetaService: PageMetaService,
    private readonly reportService: ReportService
  ) {


    this.loggedinUser = this.authService.user;
    this.url$ = this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.url));
    this.url$.subscribe((resp) => { this.currentURL = resp; });
  }

  ngOnInit(): void {
    this.sideBarSection = new SideBarSection(this.authService, this.appGlobals);
    // * Enable lead admin module for specifc user
    const loggedinUser = this.authService.user;
    if (Array.isArray(this.appGlobals.leadAdminModuleAccessUser) && this.appGlobals.leadAdminModuleAccessUser.includes(loggedinUser.email)) {
      this.isLeadAdminModuleAccess = true;
    }

    // check if can show beneficiary module
    this.sharedService.currentKYCStatus.subscribe((response) => {
      if (response && response == this.appGlobals.KYC_STATUSES.APPROVED) {
        this.canShowBeneficiary = true;
      } else {
        this.canShowBeneficiary = false;
      }
    });

    this.entityService.currentCompanySelection$.subscribe((response) => {
      if (response) {
        if (this.authService.user?.isOwner && !this.authService.user?.isAdmin) {
          if (this.authService.user?.isSecondaryOwner && this.authService.user?.userAccessList.includes('Payments')) {
            this.sharedService.getKYC();
          } else if (this.authService.user?.isOwner && !this.authService.user?.isSecondaryOwner) {
            this.sharedService.getKYC();
          }
        }

        if (this.authService.user?.isOwner || this.authService.user?.isOutlet) {
          this.voucherService.getCompanyList().subscribe(res => {
            if (res.length) {
              this.sharedService.setStandardGSTUOMForCompanies(res);
              res.forEach(company => {
                if (company.restaurantSyncCode && company.restaurantSyncCode !== '') {
                  if (this.authService.user.isSecondaryOwner) {
                    if (this.authService.user.userAccessList.includes(this.appGlobals.USER_ACCESS.PETPOOJA_POS)) {
                      this.showPushToPetpooja = true;
                    } else {
                      this.showPushToPetpooja = false;
                    }
                  } else {
                    this.showPushToPetpooja = true;
                  }
                }

                if (company.retailPosSyncCode && company.retailPosSyncCode !== '') {
                  if (this.authService.user.isSecondaryOwner) {
                    if (this.authService.user.userAccessList.includes(this.appGlobals.USER_ACCESS.PETPOOJA_INVOICE)) {
                      this.showPushToRetailPos = true;
                    } else {
                      this.showPushToRetailPos = false;
                    }
                  } else {
                    this.showPushToRetailPos = true;
                  }
                }

                if (company.tallySyncCode && company.tallySyncCode !== '') {
                  if (this.authService.user.isSecondaryOwner) {
                    if (this.authService.user.userAccessList.includes(this.appGlobals.USER_ACCESS.PUSH_TO_TALLY)) {
                      this.showPushToTally = true;
                    } else {
                      this.showPushToTally = false;
                    }
                  } else {
                    this.showPushToTally = true;
                  }
                }
              });
              this.fetchSidebarMenus();
            }
          }, (error) => {
            this.fetchSidebarMenus();
          })
        } else {
          this.showPushToPetpooja = true;
          this.showPushToRetailPos = true;
          this.showPushToTally = true;
          this.reportService.hasAdminAccess().subscribe({
            next: (response: any) => {
              if (response?.adminAccess?.canViewReports) {
                this.canAdminViewReport = true;
              }
              if (response?.adminAccess?.canUpload) {
                this.canAdminUpload = true;
              }
              this.fetchSidebarMenus();
            },
            error: (error) => {
              console.log("error", error);
              this.fetchSidebarMenus();
            }
          });

          if (this.authService.user?.isAdmin) {
            this.voucherService.getCompanyList().subscribe(res => {
              if (res.length) {
                this.sharedService.setStandardGSTUOMForCompanies(res);
              }
            }, (error) => {
              this.sharedService.errorAlert(error);
            });
          }
        }
      }
    })



    this.token = this.authService.token;

    this.sharedService.currentLoggedInUserThumbnail.subscribe((thumbnail) => {
      this.loggedInUserThumbnail = thumbnail;
    });

    let screenWidth = window.innerWidth;
    this.checkForMobileSubMenu(screenWidth);
  }

  /**
   * This method will fetch dynamic menus based on the conditions
   */
  fetchSidebarMenus() {
    const roleAndIsPaidObject = {
      isAdmin: this.authService.user?.isAdmin,
      isLeadAdmin: this.authService.user?.isLeadAdmin,
      isOwner: this.authService.user?.isOwner,
      isPaidUser: this.authService.user.isPaidUser
    }

    const pushToAndBeneficiaryToggles = {
      showPushToPetpooja: this.showPushToPetpooja,
      showPushToRetailPos: this.showPushToRetailPos,
      showPushToTally: this.showPushToTally,
      showBeneficiary: this.canShowBeneficiary
    }
    this.topSections = this.sideBarSection.topSections(roleAndIsPaidObject, pushToAndBeneficiaryToggles, this.isLeadAdminModuleAccess, this.canAdminViewReport, this.canAdminUpload);
    if (this.topSections?.length) {
      this.topSections.forEach((section) => {
        if (section?.menus?.length) {
          section.menus.forEach((menu) => {
            if (menu.subMenus?.length) {
              menu.isSubmenuOpen = false;
            }
          })
        }
      })
    }

    this.bottomSections = this.sideBarSection.bottomSections(roleAndIsPaidObject);
    if (this.bottomSections?.length) {
      this.bottomSections.forEach((section) => {
        if (section?.menus?.length) {
          section.menus.forEach((menu) => {
            if (menu.subMenus?.length) {
              menu.isSubmenuOpen = false;
            }
          })
        }
      })
    }
  }

  getCompanyDetails() {
    this.voucherService.getCompanyDetails().subscribe(res => {
      console.log("RES: ", res);

      if (res["restaurantSyncCode"]) {
        this.showPushToPetpooja = true;
      }

      if (res["retailPosSyncCode"]) {
        this.showPushToRetailPos = true;
      }

      if (res["tallySyncCode"]) {
        this.showPushToTally = true;
      }
    }, (error) => {
      this.sharedService.errorAlert(error)
    });
  }


  logout() {
    this.sharedService.resetSelectedEntityFormControl();
    if (this.token) {
      this.authService.logout(this.token);
    } else {
      this.authService.logout();
      this.sharedService.cancelAPICalls$.next();
    }
  }

  onOpenConfirmDetailModalComponent() {
    this.sharedService.isPremiumUser.next(true);
  }


  openInnerSidebar(menu: any) {
    this.activeMenu = menu;
    this.pageMetaService.activeMenu.next(menu || []);

    if (this.activeMenu.subMenus?.length > 0) {
      this.isSettingsSidebar = true;
      if (this.isSettingsSidebar) {
        localStorage.setItem('isSettingsSidebarOpen', JSON.stringify(true));
      }
    }
    else {
      localStorage.setItem('isSettingsSidebarOpen', JSON.stringify(false));
    }
  }
  closeMobileSidebar() {
    const sideBarElement = document.getElementById('leftSidebarMenu');
    if (sideBarElement) {
      document.body.classList.remove('pmd-body-open');
      sideBarElement.classList.remove('sidebar-open');
      // ✅ Remove the generated div
      const extraDiv = document.querySelector('.pmd-sidebar-overlay');
      if (extraDiv) {
        extraDiv.remove();
      }
      this.cdRef.detectChanges();
    }
  }
  getTrialPercent(): number {
    const remaining: any = this.authService.user?.remainingFreeTrialDays ?? 0;
    const used = 10 - remaining;
    return Math.min((used / 10) * 100, 100);
  }

  getRemainingFreeTrialDays() {
    const rawDays = this.authService.user?.remainingFreeTrialDays ?? 0;
    const days = Number(rawDays); // force conversion to number
    return isNaN(days) ? 0 : days;
  }


  ngOnDestroy(): void {
    this.productTagsSubscription?.unsubscribe();
    this.companyDetailsSubscription?.unsubscribe();
  };

  checkForMobileSubMenu(screenWidth) {
    if (screenWidth <= 1399) {
      this.canShowMobileSubmenu = true;
    } else if (screenWidth > 1399) {
      this.canShowMobileSubmenu = false;
    }
  }

  onSidebarMenuClick(menu) {
    if (this.canShowMobileSubmenu) {
      menu.isSubmenuOpen = !menu.isSubmenuOpen
    } else {
      this.openInnerSidebar(menu)
    }
    if (!menu.subMenus?.length) {
      this.closeMobileSidebar();
    }

  }

  @HostListener('window:resize', ['$event']) onResize(event: any) {
    this.checkForMobileSubMenu(event.target.innerWidth);
  }
}